import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

const Invoice = (props: SvgIconProps) => {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path d="M13,13.5a.5.5,0,0,1-.5.5h-4a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h4a.5.5,0,0,1,.5.5Zm3-4a.5.5,0,0,1-.5.5h-7A.5.5,0,0,1,8,9.5v-1A.5.5,0,0,1,8.5,8h7a.5.5,0,0,1,.5.5ZM19,2H5A1,1,0,0,0,4,3V19.26a1.05,1.05,0,0,0,.29.71l1.89,1.88a.47.47,0,0,0,.35.15h.29a.47.47,0,0,0,.35-.15L9,20a.5.5,0,0,1,.35-.15A.51.51,0,0,1,9.7,20l1.81,1.81a.47.47,0,0,0,.35.15h.29a.47.47,0,0,0,.35-.15L14.32,20a.5.5,0,0,1,.35-.15A.51.51,0,0,1,15,20l1.81,1.81a.47.47,0,0,0,.35.15h.29a.47.47,0,0,0,.35-.15L19.71,20a1,1,0,0,0,.29-.7V3A1,1,0,0,0,19,2ZM18,18.86l-.66.66h0l-.74-.73-.16-.16h0l-.34-.34a1,1,0,0,0-.7-.29H14a1,1,0,0,0-.71.29L12,19.53l-1.24-1.24a1,1,0,0,0-.7-.29H8.61a1,1,0,0,0-.7.29L6.68,19.52h0L6,18.84V4H18Z" />
    </SvgIcon>
  );
};

export default Invoice;
